import { useCallback, useMemo } from 'react';
import { Button, Key2LineIcon, Modal, Paragraph, Space } from 'ui';

type P = {
  onLoginWithPasskey: () => void;
  onSendPassword: () => void;
};

export const usePasskeyLoginModal = () => {
  const [modal, contextHolder] = Modal.useModal();

  const showPasskeyLoginModal = useCallback(
    ({ onLoginWithPasskey, onSendPassword }: P) => {
      modal.confirm({
        content: (
          // TODO: this 22 is size of one line
          <Space size={22} vertical>
            <Paragraph>
              Use a passkey to log in with biometric authentication or your device&apos;s security. Passkeys are faster
              and more secure than passwords—and will be required soon.
            </Paragraph>
            <Paragraph>
              If you can’t use a passkey, you can get a one‑time password sent to your email instead.
              <Button
                onClick={() => {
                  onSendPassword();
                }}
                type="link-primary"
              >
                Send me the password
              </Button>
            </Paragraph>
          </Space>
        ),
        icon: <Key2LineIcon />,
        okText: 'Log in with passkey',
        onOk() {
          onLoginWithPasskey();
        },
        title: 'Log in with Your Passkey',
      });
    },
    [modal],
  );

  return useMemo(
    () => ({
      contextHolder,
      showPasskeyLoginModal,
    }),
    [contextHolder, showPasskeyLoginModal],
  );
};
